document.addEventListener("DOMContentLoaded", () => {
    const addAttachmentButton = document.querySelector(".attachments-container button")
    if (!addAttachmentButton) return // Exit if the button is not found

    addAttachmentButton.addEventListener("click", (event) => {
        event.preventDefault() // Prevent default button behavior

        const attachmentsInput = addAttachmentButton.parentNode.querySelector("#email_message_attachments")
        if (attachmentsInput) {
            attachmentsInput.click() // Trigger the click on the file input
        } else {
            console.warn("Attachments input field (#email_message_attachments) not found.")
        }
    })
})
